{
    "filter_header__title": "Filters used",
    "filter_header__title_short": "Filter",
    "filter_header__filter_button": "Filter",
    "filter_header__delete_button": "Remove",
    "filter_header__delete_all_button": "Remove all"
}
